module.exports = __webpack_public_path__ + "static/media/badge-santander-desktop.998e31b8.svg";